import { Outlet, Navigate } from "react-router-dom";
import { Sidebar } from "./sidebar";
import { useAuth } from "@/hooks/use-auth";

export function AppLayout() {
  const { isAuthenticated, logout } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar onLogout={logout} />
      <main className="flex-1 overflow-y-auto bg-background p-6">
        <Outlet />
      </main>
    </div>
  );
}
